import { useEffect } from "react";
import { EditorContent, useEditor } from "@tiptap/react";
import {
  getMarkdownFromEditor,
  waveMarkdownExtensions,
} from "./waveMarkdownExtensions";

export type WaveMarkdownPreviewClamp = "stub" | "soft" | "none";

export type WaveMarkdownPreviewProps = {
  markdown: string;
  className?: string;
  /** `stub` = 2 righe nel collasso annidato; `soft` = eredita il clamp del widget. */
  clamp?: WaveMarkdownPreviewClamp;
};

export function WaveMarkdownPreview({
  markdown,
  className = "",
  clamp = "none",
}: WaveMarkdownPreviewProps) {
  const source = markdown ?? "";

  const tiptapEditor = useEditor(
    {
      extensions: waveMarkdownExtensions(),
      content: source,
      editable: false,
      editorProps: {
        attributes: {
          class: "wave-md-editor__content",
        },
      },
    },
    [],
  );

  useEffect(() => {
    if (!tiptapEditor) return;
    const current = getMarkdownFromEditor(tiptapEditor);
    if (current === source) return;
    tiptapEditor.commands.setContent(source, false);
  }, [source, tiptapEditor]);

  return (
    <div
      className={[
        "wave-md-editor",
        "wave-md-editor--readonly",
        "wave-md-preview",
        clamp !== "none" ? `wave-md-preview--${clamp}` : "",
        className,
      ]
        .filter(Boolean)
        .join(" ")}
    >
      <EditorContent editor={tiptapEditor} />
    </div>
  );
}
